export const appVersion = '0.34.0';
